import img1 from '../../static/img/class_types_page/FiveStages_Low_Impact_Dance_Fitness.webp';
import img2 from '../../static/img/class_types_page/FiveStages_Low_Impact_Dance_Fitness_2.webp';
import quoteImg from '../../static/img/class_types_page/FiveStages_Low_Impact_Dance_Fitness_3.webp';

const Class = {
  code: '5stages',
  name: 'The Five Stages Class',
  sentence1: 'The Nia Five Stages class offers gentle, mindful, self-healing movement as you are guided through five stages of human development – embryonic, creeping, crawling, standing and walking. Re-align, energize and condition your body, mind, emotions and spirit. Move better, feel better from the ground up.',
  sentence2: '',
  quoteSentence1: 'Nia has changed my relationship with my body and fitness. I have developed a strength and fluidity in my body that I never gained with traditional fitness. Nia is truly a sustainable movement practice that I will be able to use my whole life!',
  quoteAttr: 'Shayne W., Nia Student',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A person laying on the floor on their side during a Nia low impact dance fitness class',
  img2Alt: 'A group of people moving around on their hands and knees to practice somatic movements during a Nia low impact dance fitness class',
  quoteAlt: 'A quote that says "The art of self healing" in green script writing, illustrating how meaningful Nia\'s low impact dance fitness classes are',
};

export default Class;
